import createIcon from '../../createIcon';

/**
 * @component @name Publish
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNSA0VjZIMTlWNEg1Wk01IDE0SDlWMjBIMTVWMTRIMTlMMTIgN0w1IDE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Publish = createIcon('Publish', [
  ['path', { d: 'M5 4V6H19V4H5ZM5 14H9V20H15V14H19L12 7L5 14Z', key: 'wre9o4' }],
]);

export default Publish;
